// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MissionBlock_root__-0GA9 {
  padding: 40px 0;
}
.MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL {
  padding: 40px 0;
}
.MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_titleBlock__zQ2SP p {
  font-size: 24px;
  font-weight: bold;
  color: #00377c;
}
.MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_missionBlock__vDsE- {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 251px);
  padding: 20px 0;
}
.MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_missionBlock__vDsE- .MissionBlock_card__X8YFO {
  height: 100%;
  color: #fff;
  background: #00377c;
  --bs-card-border-width: none;
  --bs-card-border-radius: 25px;
}
.MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_missionBlock__vDsE- .MissionBlock_card__X8YFO .MissionBlock_cardBody__nVK5B {
  text-align: center;
}
.MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_missionBlock__vDsE- .MissionBlock_card__X8YFO .MissionBlock_cardBody__nVK5B .MissionBlock_cardTitleBlock__wx8O7 {
  font-size: 80px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .MissionBlock_root__-0GA9 {
    padding: 20px 0 0 0;
  }
  .MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL {
    padding: 20px 0 0 0;
  }
  .MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_titleBlock__zQ2SP p {
    font-size: 18px;
  }
  .MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_missionBlock__vDsE- .MissionBlock_card__X8YFO {
    font-size: 14px;
  }
  .MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_missionBlock__vDsE- .MissionBlock_card__X8YFO .MissionBlock_cardBody__nVK5B .MissionBlock_cardTitleBlock__wx8O7 {
    font-size: 55px;
  }
}
@media (max-width: 500px) {
  .MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_titleBlock__zQ2SP p {
    font-size: 16px;
  }
  .MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_missionBlock__vDsE- .MissionBlock_card__X8YFO {
    font-size: 12px;
  }
  .MissionBlock_root__-0GA9 .MissionBlock_wrapper__om5nL .MissionBlock_missionBlock__vDsE- .MissionBlock_card__X8YFO .MissionBlock_cardBody__nVK5B .MissionBlock_cardTitleBlock__wx8O7 {
    font-size: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/AboutUsMenu/MissionBlock/MissionBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,eAAA;AACJ;AAEM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAAR;AAII;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AAFN;AAIM;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;AAFR;AAIQ;EACE,kBAAA;AAFV;AAIU;EACE,eAAA;EACA,iBAAA;AAFZ;;AAUA;EACE;IACE,mBAAA;EAPF;EASE;IACE,mBAAA;EAPJ;EAUM;IACE,eAAA;EARR;EAaM;IACE,eAAA;EAXR;EAcU;IACE,eAAA;EAZZ;AACF;AAoBA;EAIQ;IACE,eAAA;EArBR;EA0BM;IACE,eAAA;EAxBR;EA2BU;IACE,eAAA;EAzBZ;AACF","sourcesContent":[".root {\n  padding: 40px 0;\n\n  .wrapper {\n    padding: 40px 0;\n\n    .titleBlock {\n      p {\n        font-size: 24px;\n        font-weight: bold;\n        color: #00377c;\n      }\n    }\n\n    .missionBlock {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      min-height: calc(100vh - 251px);\n      padding: 20px 0;\n\n      .card {\n        height: 100%;\n        color: #fff;\n        background: #00377c;\n        --bs-card-border-width: none;\n        --bs-card-border-radius: 25px;\n\n        .cardBody {\n          text-align: center;\n\n          .cardTitleBlock {\n            font-size: 80px;\n            font-weight: bold;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding: 20px 0 0 0;\n\n    .wrapper {\n      padding: 20px 0 0 0;\n\n      .titleBlock {\n        p {\n          font-size: 18px;\n        }\n      }\n\n      .missionBlock {\n        .card {\n          font-size: 14px;\n\n          .cardBody {\n            .cardTitleBlock {\n              font-size: 55px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .wrapper {\n      .titleBlock {\n        p {\n          font-size: 16px;\n        }\n      }\n\n      .missionBlock {\n        .card {\n          font-size: 12px;\n\n          .cardBody {\n            .cardTitleBlock {\n              font-size: 40px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MissionBlock_root__-0GA9`,
	"wrapper": `MissionBlock_wrapper__om5nL`,
	"titleBlock": `MissionBlock_titleBlock__zQ2SP`,
	"missionBlock": `MissionBlock_missionBlock__vDsE-`,
	"card": `MissionBlock_card__X8YFO`,
	"cardBody": `MissionBlock_cardBody__nVK5B`,
	"cardTitleBlock": `MissionBlock_cardTitleBlock__wx8O7`
};
export default ___CSS_LOADER_EXPORT___;
